import React from "react";
import { Download, Monitor, Apple, Keyboard, CheckCircle, Shield, Mic } from "lucide-react";

export default function ShortcutsPage() {
  return (
    <div className="space-y-6">
      <div className="rounded-3xl bg-gradient-to-br from-brand-navy via-brand-blue to-brand-pink text-white p-8 shadow-soft overflow-hidden relative">
        <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_top_right,#fff,transparent_35%)]" />
        <div className="relative max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-white/15 rounded-full text-xs font-semibold backdrop-blur">
            <Monitor className="w-3.5 h-3.5" /> DraftVoice Desktop App
          </div>
          <h1 className="mt-4 text-3xl md:text-4xl font-bold tracking-tight">
            Use DraftVoice across your computer
          </h1>
          <p className="mt-3 text-white/85 text-sm md:text-base leading-7">
            Install once, login once, and use DraftVoice in Gmail, ChatGPT, WhatsApp, Word,
            Notepad, CRM fields, and any text box. No Chrome developer mode. No token copy.
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href="/DraftVoiceAISetup.exe"
              download
              className="inline-flex items-center gap-2 bg-white text-brand-navy px-5 py-3 rounded-full font-semibold hover:bg-white/90 transition"
            >
              <Download className="w-4 h-4" /> Download for Windows
            </a>
            <button
              disabled
              className="inline-flex items-center gap-2 bg-white/15 text-white/70 px-5 py-3 rounded-full font-semibold cursor-not-allowed"
            >
              <Apple className="w-4 h-4" /> macOS Coming Soon
            </button>
          </div>

          <p className="mt-4 text-xs text-white/70">
            Windows app is available now. macOS version is coming soon.
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <div className="bg-white border border-brand-line rounded-2xl p-5 shadow-soft">
          <Mic className="w-6 h-6 text-brand-blue" />
          <h3 className="mt-3 font-semibold text-brand-navy">Global dictation</h3>
          <p className="text-sm text-brand-muted mt-2">
            Press the shortcut anywhere, speak, and insert text into the active field.
          </p>
        </div>

        <div className="bg-white border border-brand-line rounded-2xl p-5 shadow-soft">
          <Keyboard className="w-6 h-6 text-brand-pink" />
          <h3 className="mt-3 font-semibold text-brand-navy">Shortcut</h3>
          <p className="text-sm text-brand-muted mt-2">
            Default shortcut: <span className="font-semibold text-brand-navy">Ctrl + Shift + D</span>.
            Press once to start, press again to stop.
          </p>
        </div>

        <div className="bg-white border border-brand-line rounded-2xl p-5 shadow-soft">
          <Shield className="w-6 h-6 text-emerald-600" />
          <h3 className="mt-3 font-semibold text-brand-navy">Simple login</h3>
          <p className="text-sm text-brand-muted mt-2">
            Login with your DraftVoice account. No manual token setup required.
          </p>
        </div>
      </div>

      <div className="bg-white border border-brand-line rounded-2xl p-6 shadow-soft">
        <h2 className="text-xl font-semibold text-brand-navy">How to use DraftVoice Desktop</h2>
        <div className="mt-5 grid md:grid-cols-4 gap-4">
          {[
            "Download and install the Windows app.",
            "Open DraftVoice and login once.",
            "Press Ctrl + Shift + D in any text field.",
            "Speak, press again to stop, and the text will be inserted."
          ].map((item, index) => (
            <div key={item} className="rounded-2xl bg-brand-light border border-brand-line p-4">
              <div className="w-8 h-8 rounded-full bg-white text-brand-blue font-bold flex items-center justify-center">
                {index + 1}
              </div>
              <p className="mt-3 text-sm text-brand-muted">{item}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-emerald-50 border border-emerald-200 rounded-2xl p-5 text-emerald-800 flex gap-3">
        <CheckCircle className="w-5 h-5 shrink-0 mt-0.5" />
        <div>
          <h3 className="font-semibold">Recommended workflow</h3>
          <p className="text-sm mt-1">
            Use the desktop app for full computer-wide dictation. The Chrome extension is no longer
            promoted as the main workflow.
          </p>
        </div>
      </div>
    </div>
  );
}
